export default "__VITE_PUBLIC_ASSET__fb3103fc__"